import React from 'react';
import PageSeo from '@/seo/PageSeo';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import CookiesContentFromMarkdown from '../components/Cookies/CookiesContentFromMarkdown';
import $ from 'jquery';
import LegalDocumentLayout from '../components/Legal/LegalDocumentLayout';

export default function CookiesPolicy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Cookies-policy',
    title: 'Cookies policy',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'cookies-policy.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  const sections = [
    { id: 'section1', number: '01', label: 'What is a cookie?' },
    { id: 'section2', number: '02', label: 'How we use cookies' },
    { id: 'section3', number: '03', label: 'Cookie types' },
    { id: 'section4', number: '04', label: 'Disable cookies' },
    { id: 'section5', number: '05', label: 'Cookies table' },
  ];

  const contactCard = {
    title: 'Privacy Contact',
    email: 'dataprotection@disgenet.com',
    phone: '933037654',
  };

  return (
    <React.Fragment>
      <PageSeo
        title="Cookies Policy | DISGENET"
        description="Cookie types, purposes and consent options used on the DISGENET website and gene-disease association platform."
        path="/Cookies-policy"
      />
      <section>
        <LegalDocumentLayout
          heroTag="Cookies Policy"
          heroTitle={
            <>
              Cookie use and <em>tracking</em> controls
            </>
          }
          heroSubtitle="Learn which cookies we use, why we use them, and how you can manage your consent preferences."
          sections={sections}
          contact={contactCard}
          onDownload={downloadSummary}
        >
          <CookiesContentFromMarkdown />
        </LegalDocumentLayout>
      </section>
    </React.Fragment>
  );
}
